/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import omit from 'lodash/fp/omit.js';
import pipe from 'lodash/fp/pipe.js';
import { arrayUnshift } from 'redux-form';
import {
  COMPONENT_ID,
  DEFAULT_EDP,
} from '@hbrisk/sp3-risk-model-support/components/app/attributes/names/index.js';
import {
  COMPONENT_POPULATION,
  COMPONENT_POPULATION_COMPONENT_UUID,
  COMPONENT_POPULATION_PERFORMANCE_GROUPS,
  PERFORMANCE_GROUP_LOCATIONS,
  PERFORMANCE_GROUP_NAME,
  PERFORMANCE_GROUP_RESPONSE_ITEM_KEY,
  PERFORMANCE_GROUP_SERVICE_LOCATIONS,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';

import { RESPONSE_ITEM_KEY_USE_DEFAULT } from '@hbrisk/sp3-risk-model-support/models/app/attributes/values/index.js';
import { selectComponentsByUuid } from '#selectors/entities/components.js';
import withNavigate from '#components/support/routing/withNavigate/index.jsx';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import getLocationDefaults from '#components/pages/Models/Model/sections/type2/BuildingComponentsTableSection/support/getLocationDefaults/index.js';

import render from './render.jsx';

const mapStateToProps = (_, ownProps) => {
  const { form } = ownProps;
  const { makeFieldIsAutofilledSelector } = modelTypesByForm[form];
  const selectFieldIsAutofilled = makeFieldIsAutofilledSelector();
  return state => {
    const autofilled = selectFieldIsAutofilled(state, { name: COMPONENT_POPULATION });
    const componentsById = selectComponentsByUuid(state);
    return {
      componentsById,
      autofilled,
    };
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { form, navigate } = ownProps;

  return {
    makeHandleAdd: (componentId, componentUuid) => () => {
      const componentPopulationItem = {
        [COMPONENT_POPULATION_COMPONENT_UUID]: componentUuid,
        [COMPONENT_POPULATION_PERFORMANCE_GROUPS]: [
          {
            [PERFORMANCE_GROUP_NAME]: `${componentId} #1`,
            [PERFORMANCE_GROUP_RESPONSE_ITEM_KEY]: RESPONSE_ITEM_KEY_USE_DEFAULT,
            [PERFORMANCE_GROUP_LOCATIONS]: [getLocationDefaults()],
            [PERFORMANCE_GROUP_SERVICE_LOCATIONS]: null,
          },
        ],
      };

      const recentlyAdded = {
        [COMPONENT_POPULATION_COMPONENT_UUID]: componentUuid,
        dateTime: Date.now(),
      };

      dispatch(arrayUnshift(form, COMPONENT_POPULATION, componentPopulationItem));
      navigate('..', { state: { recentlyAdded } });
    },
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { componentsById } = stateProps;
  const { makeHandleAdd } = dispatchProps;
  return {
    ...ownProps,
    ...omit('componentsById', stateProps),
    handleAdd: componentUuid => {
      if (!componentUuid) {
        return null;
      }
      const component = componentsById[componentUuid];
      const edp = component[DEFAULT_EDP];
      const componentId = component[COMPONENT_ID];
      return makeHandleAdd(componentId, componentUuid, edp);
    },
  };
};
export default pipe(connect(mapStateToProps, mapDispatchToProps, mergeProps), withNavigate)(render);
